import type { ModalProps } from '@components/v2/ui/Modal/modal.types';
import React from 'react';
import { renderRootModal } from '../components/Modal/ModalRoot';

type ModalRendererOptions = {
  component: React.FC<Pick<ModalProps, 'isOpen' | 'onClose'>>;
};

export function dynamicRenderModal({ component: Component }: ModalRendererOptions) {
  const handleClose = () => {
    setTimeout(() => {
      renderRootModal(null);
    }, 300);
  };

  renderRootModal(<Component isOpen onClose={handleClose} />);
}
